import {FETCH_LIVE, ADD_ACTION, DELETE_ACTION, EDIT_ACTION, SCORE, END_LIVE, RESET_DEMO} from '../constants';
import _ from 'lodash';
import moment from 'moment';

export default (state = [], action) => {
    const key = action && action.payload ? `/api/lives/${action.payload.id}` : '';
    let nextState = {};
    const caches = localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : {}
    const cache_ttl = caches.cache_ttl_expires_at ? caches.cache_ttl_expires_at : moment().add(1, 'week').unix();
    switch(action.type) {
        case FETCH_LIVE: return {...state, [action.payload.key]: _.assignIn(action.payload.live, {match: action.payload.match})};
        case ADD_ACTION:
            if(state[key] && !_.isEmpty(state[key])) {
                _.assignIn(state[key], {actions: [...action.payload.live.actions]});
                nextState = {...state}
                localStorage.setItem(key, JSON.stringify(_.assignIn(nextState[key], {cache_ttl_expires_at: cache_ttl})));
            }
            return {...state};
        case EDIT_ACTION:
            if(state[key] && !_.isEmpty(state[key])) {
                const actionToEdit = _.find(state[key].actions, a => a['@id'] === action.payload.live['@id']);
                _.assign(actionToEdit, {data: action.payload.live.data});
                nextState = {...state}
                localStorage.setItem(key, JSON.stringify(_.assignIn(nextState[key],{cache_ttl_expires_at: cache_ttl})));
            }
            return {...state};
        case DELETE_ACTION:
            if(state[key] && !_.isEmpty(state[key])) {
                _.remove(state[key].actions, v => v['@id'] === action.payload.action);
                nextState = {...state}
                localStorage.setItem(key, JSON.stringify(_.assignIn(nextState[key],{cache_ttl_expires_at: cache_ttl})));
            }
            return {...state};
        case SCORE:
            if(state[key] && !_.isEmpty(state[key])) {
                _.set(state[key], 'score', action.payload.score);
            }
            nextState = {...state}
            localStorage.setItem(key, JSON.stringify(_.assignIn(nextState[key],{cache_ttl_expires_at: cache_ttl})));
            return nextState;
        case END_LIVE:
            if(state[key] && !_.isEmpty(state[key])) {
                _.set(state[key], 'ended', true);
            }
            nextState = {...state};
            localStorage.setItem(key, JSON.stringify(_.assignIn(nextState[key],{cache_ttl_expires_at: cache_ttl})));
            return nextState;
        case RESET_DEMO:
            nextState = _.omit(state, '/api/lives/demo')
            return nextState;
        default: return state;
    }
}